var map = {
	"./budgetcap/budgetcap.module": [
		"./src/app/home/budgetcap/budgetcap.module.ts",
		"budgetcap-budgetcap-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./home/welcomepage/welcomepage.module": [
		"./src/app/home/welcomepage/welcomepage.module.ts",
		"home-welcomepage-welcomepage-module"
	],
	"./managecashpayment/managecashpayment.module": [
		"./src/app/home/managecashpayment/managecashpayment.module.ts",
		"managecashpayment-managecashpayment-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;